export default "__VITE_ASSET__XAid5tM$__"